import { computed } from 'mobx';
import { PartialDeep } from 'type-fest';

import { translate } from 'services/i18nService';
import { AbstractTheme, CampaignFlagsMap, ControlledFeaturesMap, Theme } from 'themes/themes.types';
import { getThemePart } from 'themes/utils';
import UserStore from 'stores/UserStore';
import { MINUTE_AS_MILLISECONDS } from 'enum/timeFormat';
import ACCESS_LEVEL_NUM from 'enum/accessLevelsNum';

import styles from './SecondPurchaseTheme.css';


const SLOGAN_TRANSLATE_KEY = 'campaigns.secondPurchase.title';
const TOKEN_OFFER_TRANSLATE_KEY = 'campaigns.secondPurchase.getTokens';
const ON_CAM_TRANSLATE_KEY = 'campaigns.secondPurchase.animText1';

export default class SecondPurchaseTheme extends AbstractTheme {
  static CFS: ControlledFeaturesMap = {};
  static CAMPAIGN_FLAGS: CampaignFlagsMap = {
    ON_CAM_ANIMATION: 'SECOND_PURCHASE_ON_CAM_ANIMATION',
    HEADER_CTA: 'SECOND_PURCHASE_HEADER_CTA',
    BUY_TOKENS_MODAL: 'SECOND_PURCHASE_BUY_TOKENS_MODAL',
  };

  @computed get theme(): PartialDeep<Theme> {
    const { user: { accessLevel } } = UserStore;
    const isGoldUser = accessLevel >= ACCESS_LEVEL_NUM.GOLD;

    return {
      onCamAnimation: getThemePart<'onCamAnimation'>(
        SecondPurchaseTheme.CAMPAIGN_FLAGS.ON_CAM_ANIMATION,
        (campaign) => {
          return {
            delay: 5 * MINUTE_AS_MILLISECONDS,
            cookieNamePrefix: campaign.activeCampaignName,
            animBackgroundClass: isGoldUser ? styles.animBackgroundGold : styles.animBackground,
            animBackground2Class: isGoldUser ? styles.animBackground2Gold : undefined,
            staticBackgroundClass: isGoldUser ? styles.staticBackgroundGold : styles.staticBackground,
            animTextClass: styles.animText,
            animWrapperClass: styles.animWrapper,
            line1Text: translate(ON_CAM_TRANSLATE_KEY,
              { 0: campaign.campaignDetails.bonusTokenPercent }
            ),
          };
        }
      ),

      headerCTA: getThemePart<'headerCTA'>(
        SecondPurchaseTheme.CAMPAIGN_FLAGS.HEADER_CTA,
        (campaign) => {
          return {
            cookieNamePrefix: campaign.activeCampaignName,
            wrapperClass: styles.headerCTAWrapper,
            title: translate(SLOGAN_TRANSLATE_KEY),
          };
        }
      ),

      buyTokensModal: getThemePart<'buyTokensModal'>(
        SecondPurchaseTheme.CAMPAIGN_FLAGS.BUY_TOKENS_MODAL,
        (campaign) => {
          return {
            cookieNamePrefix: campaign.activeCampaignName,
            headerClass: styles.buyTokensModalHeader,
            title: translate(SLOGAN_TRANSLATE_KEY),
            text: translate(TOKEN_OFFER_TRANSLATE_KEY,
              { 0: campaign.campaignDetails.bonusTokenPercent }
            ),
          };
        }
      ),

    };
  }
}
